export default __webpack_public_path__ + "static/media/bubble1.79a4014d.mp3";